jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS
        var wdata = [];
        wdata.scap = false;
        wdata.scapLoad = false;

        $(window).on('load', function(){
            winLoad();
        });

        function winLoad(){
            wdata.scapLoad= true;
            bindStoneCaptcha();
        }

        function bindStoneCaptcha(){
         //   console.log('bind');
            if ($('input[name=stone_captcha]').length>0) {
                $('body').one('click', function(){
                    if (wdata.scap == false) {
                        getStoneCaptcha();
                    }
                });
            }
        }

        var schr = null
        function getStoneCaptcha(){
            schr = $.ajax({
                url: ajax_url,
                timeout: 35000,
                type: 'POST',
                cache: false,
                data: ({
                    action: 'get_stone_captcha',
                    url: window.location.href,
                }),
                beforeSend: function(){
                },
                success: function(data) {
                    wdata.scap = data;
                  //  console.log(data);
                    $('input[name=stone_captcha]').val(data);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        setTimeout(function(){
            if (wdata.scapLoad == false) {
                winLoad();
            }
        }, 3000);

        //Document Ready ENDS
    });
})(jQuery);